import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderChernivtsi(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-chernivtsi/create-distribution-order-chernivtsi",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderChernivtsi(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-chernivtsi/create-distribution-to-order-chernivtsi",
      params,
      callBackFn
    );
  },
  async getChernivtsiAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-chernivtsi/get-chernivtsi-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
